// External libraries
import { css } from '@emotion/core';

// Internal modules
import {
  HEADER_COLOR,
  WARNING_COLOR,
  WARNING_MESSAGE_BACKGROUND_COLOR,
} from '@/styles';

export const errorFieldStyleOverrides = css`
  background-color: ${WARNING_MESSAGE_BACKGROUND_COLOR};
  border: 1px solid ${WARNING_COLOR};
  border-radius: 4px;
  margin-bottom: 16px;
  padding: 13px;

  p {
    color: ${HEADER_COLOR};
    font-weight: 400;
  }
`;
